/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.estadosdetalles': 'Estados Detalles',
  'estadosDetalles.agregarEstadosDetalles': 'Crear Estados Detalles',
  'estadosDetalles.confirmacionCreacion': '¿Está seguro que desea crear el registro?',
  'estadosDetalles.confirmacionEdicion': '¿Está seguro que desea editar el registro?',
  'estadosDetalles.confirmacionEliminacion': '¿Está seguro que desea eliminar el registro?',
  'estadosDetalles.modificarEstadosDetalles': 'Editar Estados Detalles',
  'estadosDetalles.estadoDetalleId': 'Estado Detalle Id',
  'estadosDetalles.empresaId': 'Empresa Id',
  'estadosDetalles.descripcionEstadoDetalle': 'Descripción Estado Detalle',
  'estadosDetalles.VerEstadosDetalles': 'Ver Estados Detalles',
};
